module.exports = __webpack_public_path__ + "static/green-dragon-025237e20a468ad6696f8feb2a7d50ab.png";